const Heart = (props) => (
  <svg width='72.617' height='67.627' viewBox='0 0 72.617 67.627' fill='#fff' {...props}>
    <path
      d='M64.845,5.432a20.044,20.044,0,0,1,5.772,14.514A20.044,20.044,0,0,1,64.845,34.46L35.308,65.185,5.772,34.46A20.044,20.044,0,0,1,0,19.946,20.044,20.044,0,0,1,5.772,5.432,16.442,16.442,0,0,1,18.248,0,16.442,16.442,0,0,1,30.725,5.432l4.583,4.753,4.753-4.753a16.85,16.85,0,0,1,24.784,0Z'
      transform='translate(1 1)'
      stroke='#e9ecf2'
      strokeWidth='2'
    />
  </svg>
)

export default Heart
